/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { toast } from 'react-toastify';
import TextField from '../../../bootstrap/TextField';
// import languageData from "../../../lib/lang.config.json";
import { ticketTracking } from '../../../redux/action/busAction';
import Payment from '../Payment/index.jsx';
import { PaymentHelper } from '../PaymentGateway/PaymentHelper';
import ReturnTravellerInformation from '../ReturnTravellerInformation';
import SingleTravellerInformation from '../SingleTravellerInformation';
import {
   FirstNameAndNid,
   Nid,
   Passenger,
   Select,
   UserContactWrapper,
} from '../SingleTravellerInformation/singleTravellerInformation.styles';
import {
   FormSection,
   InformationHeader,
   TravelarInformation,
} from './TravellerInformation.styles.js';

const TravellerInformation = ({
   passengerInformation,
   setPassengerInformation,
   values,
   setValues,
   handleChange,
   isRegesteredUser,
   discountValue,
   setDiscountValue,
   returnAmmount,
   regularAmmount,
   subTripid,
   setLoading,
   token,
   paymentStutas,
   setPaymentStutas,
}) => {
   const { webSettingData } = useSelector((state) => state.busLists);
   const languageData = useSelector((state) => state.busLists.languageData);
   const fareSummery = useSelector((state) => state.fareSummery);
   const [countryName, setCountryName] = useState([]);
   const [searchInfo, setSearchInfo] = useState(null);
   const [bookingInfo, setBookingInfo] = useState(null);
   const [paymentGateway, setpaymentGateway] = useState('');

   const [extraPassengers, setExtraPassengers] = useState({});
   const [roundTripPassengers, setRoundTripPassengers] = useState({});
   const [journeyInfo, setJourneyInfo] = useState({});
   const [returnSearchInfo, setReturnSearchInfo] = useState({});
   const [returnFirstJourneyInfo, setReturnFirstJourneyInfo] = useState({});
   const history = useHistory();
   const [isChecked, setIsChecked] = useState(false);
   const [paypalShow, setPaypalShow] = useState(false);
   const [paystackShow, setPaystacklShow] = useState(false);
   const [stripeShow, setStripeShow] = useState(false);
   const [paytmShow, setPaytmShow] = useState(false);
   const [razorpayShow, setRazorpayShow] = useState(false);
   const [sslcommerz, setSslcommerz] = useState(false);
   const [journeyInfoTax, setJourneyInfoTax] = useState(null);
   const [bookingInfoTax, setBookingInfoTax] = useState(null);
   const [singlePaymentGateway, setSinglePaymentGateway] = useState(null);
   const [paymentGatewayNumber, setPaymentGatewayNumber] = useState(null);
   const [isDisabled, setIsDisabled] = useState(false);
   const [userProfileInfo, setUserProfileInfo] = useState({});
   const [idError, setIdError] = useState('');

  const validateIdNumber = (value) => {
    // Only allow numeric values
    const numericValue = value.replace(/\D/g, '');
    if (value !== numericValue) {
      setIdError('ID number must contain digits only');
      return false;
    } else {
      setIdError('');
      return true;
    }
  };

  const handleIdNumberChange = (e) => {
    const value = e.target.value;
    // Remove any non-numeric characters
    const numericValue = value.replace(/\D/g, '');
    validateIdNumber(numericValue);
    setPassengerInformation({
      ...passengerInformation,
      id_number: numericValue,
    });
  };

   useEffect(() => {
      setIsDisabled((prevState) => !prevState);
   }, [userProfileInfo]);

   useEffect(() => {
      setUserProfileInfo(JSON.parse(localStorage.getItem('userProfileInfo')));
   }, [passengerInformation, token]);

   const dispatch = useDispatch();

   const handleOnChange = () => {
      setIsChecked(!isChecked);
   };

   useEffect(() => {
      if (!countryName?.length) return;
      const kenya = countryName.find(
         (item) =>
            item?.name?.toLowerCase() === 'kenya' ||
            item?.nicename?.toLowerCase() === 'kenya'
      );

      if (kenya && passengerInformation?.country_id !== kenya?.id) {
         setPassengerInformation((prev) => ({
            ...prev,
            country_id: kenya?.id,
         }));
      }
   }, [countryName, passengerInformation?.country_id, setPassengerInformation]);

   useEffect(() => {
      setPassengerInformation((prev) =>
         prev?.id_type === 'Nid' ? prev : { ...prev, id_type: 'Nid' }
      );
   }, [setPassengerInformation]);

   useEffect(() => {
      fetch(`${process.env.REACT_APP_API_MODULE_DOMAIN}/countries`)
         .then((res) => res.json())
         .then((data) => setCountryName(data.data));
   }, []);

   useEffect(() => {
      fetch(`${process.env.REACT_APP_API_MODULE_DOMAIN}/paymethods`)
         .then((res) => res.json())
         .then((data) => {
            setSinglePaymentGateway(data?.data);
         });
   }, []);

   useEffect(() => {
      if (!singlePaymentGateway?.length) return;

      const selectedName = paymentGateway || 'mpesa';
      const result = singlePaymentGateway?.find(
         (item) => item?.name === selectedName
      );
      setPaymentGatewayNumber(result?.id);
   }, [singlePaymentGateway, paymentGateway]);

   useEffect(() => {
      setSearchInfo(JSON.parse(localStorage.getItem('searchInfo')));
      setBookingInfo(JSON.parse(localStorage.getItem('bookingInfo')));
      setJourneyInfo(JSON.parse(localStorage.getItem('journeyInfo')));
      setReturnSearchInfo(JSON.parse(localStorage.getItem('returnSearchInfo')));
      setReturnFirstJourneyInfo(
         JSON.parse(localStorage.getItem('returnFirstJourneyInfo'))
      );

      setJourneyInfoTax(JSON.parse(localStorage.getItem('journeyInfoTax')));
      setBookingInfoTax(JSON.parse(localStorage.getItem('bookingInfoTax')));
   }, [passengerInformation]);

   useEffect(() => {
      let extraPassengers = [],
         roundTripPassengers = [];

      if (journeyInfo?.isRoundTrip && bookingInfo?.totalseat > 1) {
         for (let i = 0; i < bookingInfo?.totalseat; i++) {
            roundTripPassengers.push({});
         }

         for (let i = 0; i < journeyInfo?.totalseat; i++) {
            extraPassengers.push({});
         }

         setExtraPassengers(extraPassengers);
         setRoundTripPassengers(roundTripPassengers);
      } else {
         for (let i = 0; i < bookingInfo?.totalseat; i++) {
            extraPassengers.push({});
         }
         setExtraPassengers(extraPassengers);
      }
   }, [bookingInfo]);

   const showExtraPassengersFields = () => {
      if (
         extraPassengers.length > 1 &&
         extraPassengers.length < webSettingData?.max_ticket + 1
      ) {
         return extraPassengers.slice(1).map((passenger, index) => (
            <div key={index}>
               <br />
               <SingleTravellerInformation
                  passengerIndex={index + 2}
                  values={values}
                  handleChange={handleChange}
               />
            </div>
         ));
      }
   };

   const showExtraRoundTripPassengers = () => {
      if (
         roundTripPassengers.length > 1 &&
         roundTripPassengers.length < webSettingData?.max_ticket + 1
      ) {
         return roundTripPassengers.slice(1).map((passenger, index) => (
            <div key={index}>
               <br />
               <SingleTravellerInformation
                  passengerIndex={index + 2}
                  values={values}
                  handleChange={handleChange}
               />
            </div>
         ));
      }
   };

   const showReturnPassengersFields = () => {
      if (
         roundTripPassengers.length > 1 &&
         roundTripPassengers.length < webSettingData?.max_ticket + 1
      ) {
         return roundTripPassengers.slice(1).map((passenger, index) => (
            <div key={index}>
               <br />
               <ReturnTravellerInformation
                  passengerIndex={index + 2}
                  values={values}
                  handleChange={handleChange}
               />
            </div>
         ));
      }
   };

   const allBookingInformation = {
      totalprice: fareSummery?.grandTotal,
      passengerInformation: passengerInformation,
      values: values,
      setValues: setValues,
      paymentStutas: paymentStutas,
      paymentGateway: paymentGatewayNumber,
      fareSummry: fareSummery,
      searchInfo: searchInfo,
      bookingInfo: bookingInfo,
      journeyInfo: journeyInfo,
      returnSearchInfo: returnSearchInfo,
      returnFirstJourneyInfo: returnFirstJourneyInfo,
      returnAmmount: returnAmmount,
      regularAmmount: regularAmmount,
      discountValue: discountValue?.discount,
      subTripid: subTripid,
      journeyInfoTax: journeyInfoTax,
      bookingInfoTax: bookingInfoTax,
      token: token,
   };

   const handleTicketTracking = async (id) => {
      const response = await fetch(
         `${process.env.REACT_APP_API_MODULE_DOMAIN}/tickets/bookingid/${id}`
      );
      const result = await response.json();

      if (result?.status === 'success') {
         dispatch(ticketTracking(result?.data));
         history.push('/ticket-traking');
         toast.success('success');
      }
   };

   const handleSubmitPayment = async (paymentStutas) => {
      if (!paymentGateway) {
         toast.error('select payment gateway');
         return;
      } else if (paymentGateway === 'paypal') {
         setPaypalShow(true);
         setPaystacklShow(false);
         setStripeShow(false);
         setPaytmShow(false);
         setRazorpayShow(false);
         setSslcommerz(false);
      } else if (paymentGateway === 'paystack') {
         setPaystacklShow(true);
         setPaypalShow(false);
         setStripeShow(false);
         setPaytmShow(false);
         setRazorpayShow(false);
         setSslcommerz(false);
      } else if (paymentGateway === 'stripe') {
         setStripeShow(true);
         setPaypalShow(false);
         setPaystacklShow(false);
         setPaytmShow(false);
         setRazorpayShow(false);
         setSslcommerz(false);
      } else if (paymentGateway === 'paytm') {
         setPaytmShow(true);
         setRazorpayShow(false);
         setStripeShow(false);
         setPaypalShow(false);
         setPaystacklShow(false);
         setSslcommerz(false);
      } else if (paymentGateway === 'razorpay') {
         setRazorpayShow(true);
         setPaytmShow(false);
         setStripeShow(false);
         setPaypalShow(false);
         setPaystacklShow(false);
         setSslcommerz(false);
      } else if (paymentGateway === 'sslcommerz') {
         setSslcommerz(true);
         setRazorpayShow(false);
         setPaytmShow(false);
         setStripeShow(false);
         setPaypalShow(false);
         setPaystacklShow(false);
      }
   };

   return (
      <TravelarInformation>
         <InformationHeader>
            {languageData?.checkout_page_title[webSettingData?.language]}
         </InformationHeader>

         <Passenger>
            <label htmlFor="name">
               {
                  languageData?.checkout_page_passenger_title[
                     webSettingData?.language
                  ]
               }
               <samp style={{ color: 'red' }}>
                  {' '}
                  <b>*</b>
               </samp>
            </label>
            <UserContactWrapper>
               <FirstNameAndNid>


                  <TextField
                     id={`name`}
                     name={`name`}
                     type="text"
                     disabled={isDisabled}
                     placeholder={
                        languageData?.checkout_page_passenger_input_text[
                           webSettingData?.language
                        ]
                     }
                     value={passengerInformation?.first_name}
                     onChange={(e) =>
                        setPassengerInformation({
                           ...passengerInformation,
                           first_name: e.target.value,
                        })
                     }
                     autoComplete="nope"
                  />
               </FirstNameAndNid>
               <TextField
                  type="text"
                  placeholder="Surname"
                  name={`surName`}
                  value={passengerInformation?.last_name}
                  onChange={(e) =>
                     setPassengerInformation({
                        ...passengerInformation,
                        last_name: e.target.value,
                     })
                  }
                  autoComplete="nope"
               />
            </UserContactWrapper>
         </Passenger>
         {/* end passenger */}

         <Nid>
            <label htmlFor={`nid`}>National ID <samp style={{ color: 'red' }}><b>*</b></samp></label>
            <TextField
               id={`nid`}
               name={`nationalId`}
               type="tel"
               placeholder="Enter National ID number"
               value={passengerInformation?.id_number}
               onChange={handleIdNumberChange}
               onKeyPress={(e) => {
                 // Only allow numeric keys
                 const char = String.fromCharCode(e.which);
                 if (!/[\d]/.test(char)) {
                   e.preventDefault();
                 }
               }}
            />
            {idError && (
              <div style={{ color: 'red', fontSize: '12px', marginTop: '5px' }}>
                {idError}
              </div>
            )}
         </Nid>

          {showExtraPassengersFields()}
         {roundTripPassengers.length > 1 && (
            <InformationHeader>Return Information</InformationHeader>
         )}

         {showReturnPassengersFields()}

         <Payment
            handleSubmitPayment={handleSubmitPayment}
            paymentStutas={paymentStutas}
            setPaymentStutas={setPaymentStutas}
            paymentGateway={paymentGateway}
            setpaymentGateway={setpaymentGateway}
            passengerInformation={passengerInformation}
            allBookingInformation={allBookingInformation}
            setLoading={setLoading}
         />
      </TravelarInformation>
   );
};

export default TravellerInformation;

// *1100*14#
